import React from "react";
import logo from "../assets/logo.png";
import "./Main.css";

export default function MainOnWork() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 .bg  text-dark">
      <div className="text-center p-5">
        <div className="display-1 mb-4">🚧</div>
        <h1 className="display-5 fw-bold">Page Under Construction</h1>
        <p className="lead mb-4">
          This page is coming soon. We're working on new features — check back later.
        </p>
        <div className="mb-3">
            <img src={logo} alt="Logo"/>
        </div>
        
      </div>
    </div>
  );
}